import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/switch";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export default function Settings() {
  const [days, setDays] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings/hours").then((res) => {
      const existing = res.data.days;
      if (existing && existing.length) setDays(existing);
      else setDays(DAYS.map((day) => ({ day, open: "08:30", close: "17:30", closed: day === "Sunday" })));
    });
  }, []);

  if (!days) return <div className="h-40 bg-navy border border-deep rounded-lg animate-pulse" />;

  const update = (i, patch) => setDays(days.map((d, idx) => (idx === i ? { ...d, ...patch } : d)));

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/settings/hours", { days });
      toast.success("Opening hours saved.");
    } catch (e) {
      toast.error("Could not save opening hours.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-settings" className="max-w-xl">
      <h1 className="font-heading font-extrabold text-white text-2xl tracking-tight">Opening Hours</h1>
      <p className="text-pale/50 text-sm mt-1">These hours are shown across the website. Until saved, visitors see a placeholder.</p>

      <div className="mt-6 bg-navy border border-deep rounded-lg divide-y divide-deep/60">
        {days.map((d, i) => (
          <div key={d.day} data-testid={`hours-row-${d.day.toLowerCase()}`} className="flex items-center gap-4 px-5 py-4">
            <p className="w-24 font-heading font-bold text-white text-sm">{d.day}</p>
            <div className="flex items-center gap-2 flex-1">
              <Input
                type="time"
                data-testid={`hours-open-${d.day.toLowerCase()}`}
                value={d.open}
                disabled={d.closed}
                onChange={(e) => update(i, { open: e.target.value })}
                className="bg-deep/40 border-deep text-white h-9 w-28 disabled:opacity-40"
              />
              <span className="text-pale/40 text-xs">to</span>
              <Input
                type="time"
                data-testid={`hours-close-${d.day.toLowerCase()}`}
                value={d.close}
                disabled={d.closed}
                onChange={(e) => update(i, { close: e.target.value })}
                className="bg-deep/40 border-deep text-white h-9 w-28 disabled:opacity-40"
              />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs text-pale/50">Closed</span>
              <Switch data-testid={`hours-closed-${d.day.toLowerCase()}`} checked={d.closed} onCheckedChange={(v) => update(i, { closed: v })} />
            </div>
          </div>
        ))}
      </div>

      <button onClick={save} data-testid="hours-save-btn" disabled={busy} className="btn-primary mt-6 disabled:opacity-60">
        {busy ? "SAVING..." : "SAVE OPENING HOURS"}
      </button>
    </div>
  );
}
